import { Component, OnInit, Input } from '@angular/core';
import { IUser } from '@shared/models/login.model';
import { ITaskDayDetail } from '@shared/models/task.model';
import { ToastCustomService } from '@shared/services/toast-custom.service';
import { HttpService } from 'src/app/core/http/http.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { environment } from 'src/environments/environment';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-card-event',
  templateUrl: './card-event.component.html',
  styleUrls: ['./card-event.component.scss']
})
export class CardEventComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  @Input() task: ITaskDayDetail;
  @Input() type: 'daily' | 'close';
  public user: IUser;
  constructor(
    private service: HttpService,
    private ts: ToastCustomService,
    private userService: UserService
  ) {
    super();
    this.user = this.userService.userInfo;
    this.user.photo = environment.resourcesUrl + this.user.photo;
  }

  ngOnInit() {}

  setSnooze(time: number): void {
    this.subs.add(
      this.service
        .patch(`task/${this.task.id}/snooze`, { minutes: time })
        .subscribe(data => {
          this.ts.show(
            'success',
            `Task postponed ${time} minutes`,
            'The task has been successfully postponed'
          );
        })
    );
  }
}
